const disclaimerSummary = document.querySelector('.post__disclaimer-summary');

if (disclaimerSummary) {
  disclaimerSummary.addEventListener('click', () => {
    disclaimerSummary.classList.toggle('active');
  });
}